    export const _DROPDOWN_US_STATES = [
      { value: 'AL', viewValue: 'AL'},
      { value: 'AK', viewValue: 'AK'},
      { value: 'AZ', viewValue: 'AZ'},
      { value: 'AR', viewValue: 'AR'},
      { value: 'CA', viewValue: 'CA'},
      { value: 'CO', viewValue: 'CO'},
      { value: 'CT', viewValue: 'CT'},
      { value: 'DE', viewValue: 'DE'},
      { value: 'FL', viewValue: 'FL'},
      { value: 'GA', viewValue: 'GA'},
      { value: 'HI', viewValue: 'HI'},
      { value: 'ID', viewValue: 'ID'},
      { value: 'IL', viewValue: 'IL'},
      { value: 'IN', viewValue: 'IN'},
      { value: 'IA', viewValue: 'IA'},
      { value: 'KS', viewValue: 'KS'},
      { value: 'KY', viewValue: 'KY'},
      { value: 'LA', viewValue: 'LA'},
      { value: 'ME', viewValue: 'ME'},
      { value: 'MD', viewValue: 'MD'},
      { value: 'MA', viewValue: 'MA'},
      { value: 'MI', viewValue: 'MI'},
      { value: 'MN', viewValue: 'MN'},
      { value: 'MS', viewValue: 'MS'},
      { value: 'MO', viewValue: 'MO'},
      { value: 'MT', viewValue: 'MT'},
      { value: 'NE', viewValue: 'NE'},
      { value: 'NV', viewValue: 'NV'},
      { value: 'NH', viewValue: 'NH'},
      { value: 'NJ', viewValue: 'NJ'},
      { value: 'NM', viewValue: 'NM'},
      { value: 'NY', viewValue: 'NY'},
      { value: 'NC', viewValue: 'NC'},
      { value: 'ND', viewValue: 'ND'},
      { value: 'OH', viewValue: 'OH'},
      { value: 'OK', viewValue: 'OK'},
      { value: 'OR', viewValue: 'OR'},
      { value: 'PA', viewValue: 'PA'},
      { value: 'PR', viewValue: 'PR'},
      { value: 'RI', viewValue: 'RI'},
      { value: 'SC', viewValue: 'SC'},
      { value: 'SD', viewValue: 'SD'},
      { value: 'TN', viewValue: 'TN'},
      { value: 'TX', viewValue: 'TX'},
      { value: 'UT', viewValue: 'UT'},
      { value: 'VT', viewValue: 'VT'},
      { value: 'VA', viewValue: 'VA'},
      { value: 'WA', viewValue: 'WA'},
      { value: 'WV', viewValue: 'WV'},
      { value: 'WI', viewValue: 'WI'},
      { value: 'WY', viewValue: 'WY'}
    ];

    export const EDITING_MODE = 1;
    export const ADDING_MODE = 2;


  export const BANK_HOLIDAYS = [ 
				'2026-01-01', //New Year's Day
				'2026-05-25', // Memorial Day
				'2026-07-03', // Independence Day
				'2026-09-07', // Labor Day
				'2026-11-26', // Thanksgiving
				'2026-11-27', // Thanksgiving
				'2026-12-25', // Christmas
				'2027-01-01' // New Year's Day
    ];


  export const ADMIN_IDS : number[] = [
    54,130,196,151,73,128,86,24,206,3, 39, 185, 1,78,97
  ];

  // Regions (locmain.region) whose schedule cards show the On Our Way button. Pilot: GRV + ASH.
  export const OOW_REGIONS : string[] = ['GRV', 'ASH'];

  // Training dashboard: employees who may sign off ANY training activity regardless
  // of the activity's required signoff role, prerequisite locks, or whose enrollment
  // it is (admin override). Mirrored in backend/models/training.js
  // TRAINING_SUPER_SIGNERS — keep the two in sync. ADMIN_IDS does NOT grant this.
  export const TRAINING_SUPER_SIGNER_IDS : number[] = [
    73 // Alex Earnest
  ];

  // Tag 57 = 'Mandatory Job'. A job carrying it may only be moved to another
  // schedule date, or have the tag added/removed, by the scheduling team.
  export const MANDATORY_JOB_TAG_ID = 57;

  // Builders whose scheduled QIs must have the home's square footage typed into job_notes.
  // The job dialog asks the scheduler to confirm before saving. 801 Keen, 880 Grand Living.
  export const SQFT_REMINDER_CUSTOMER_IDS: number[] = [801, 880];

  // Subdivision tags copied across every building of an MF project (keep in sync with
  // MF_PROJECT_SYNC_TAGS in backend/models/subdivisions.js): 31 ESMF registered, 65 Project Complete.
  export const MF_PROJECT_SYNC_TAG_IDS = [31, 65];

  // Auth0 login prefixes (the part before '@') for the scheduling team.
  // Hardcoded because there is no way to derive this from the database:
  // employees3.auth0_sub is null on every row, and all of these people are
  // employeetype 'S: Office', which 64 other employees also are.
  // ADMIN_IDS deliberately does NOT bypass this list.
  export const SCHEDULING_USER_PREFIXES : string[] = [
    'kathyb',   // Kathy Baisley
    'josho',    // Joshua Owens
    'amandat',  // Amanda Toler
    'jaimeem',  // Jaimee Martin-Petit
    'danem',    // Dane Martin
    'jonb'      // Jon Blount
  ];

  // Auth0 login prefixes exempt from the over-capacity modal and snackbars. Their
  // jobs still consume capacity and still flag the date, so others stay warned.
  export const CAPACITY_EXEMPT_USER_PREFIXES : string[] = [
    'jordanh'   // Jordan Hubay
  ];

  // These employees requested to be on the entire region's results emails. We haven't made this 
  // a company wide requirement/practice yet, so we've only done it for those who requested it. 

  //Used for Copying Steve G on results emails in schedule.component
  export const STEVES_EMPLOYEES : number[] = [
    203, 383, 359, 302, 224, 247, 275, 289, 309, 360, 295, 380, 337
  ];

  // Hard coded for now, use service call later
  export const JOHN_BRILEY_EMPLOYEES: number[] = [
    60, 44, 88, 90, 113, 140,205,147,148,246
  ]

  // Barris Coleman is generally unavailable Mondays and Wednesdays. Hardcoded on
  // purpose: there is no per-employee availability table and this is one rater.
  export const BARRIS_EMPLOYEE_ID: number = 400;
  // JS/moment day numbering: 0 = Sun, 1 = Mon ... 6 = Sat.
  export const BARRIS_UNAVAILABLE_DAYS: number[] = [1, 3];
  // Shown verbatim in both the job dialog and Batch Edit; keep the two in step.
  export const BARRIS_UNAVAILABLE_TITLE: string = 'Barris May Not Be Available';
  export const BARRIS_UNAVAILABLE_MSG: string =
    'Note: You are attempting to schedule Barris on a day he may not be available (Monday / Wednesday).';

  // Compliance pathway options shown under each subdivision scope.
  // Hardcoded like _DROPDOWN_US_STATES -- there is no pathwaydef dictionary table,
  // so adding an option requires a deploy.
  export const _DROPDOWN_PATHWAYS: string[] = [
    'ERI', 'ASHRAE', 'Prescriptive', 'Performance', 'Alt ES', 'Remodel'
  ];

  // Number of Stories buckets on the subdivision. Stored verbatim as the display
  // string, so changing this wording needs a data migration of sbdivisions.story_type.
  export const _DROPDOWN_STORY_TYPES: string[] = [
    '3/4 split', '3 stories or less', '4 stories or more'
  ];

  // scopedef.category values. Must stay in lockstep with SCOPE_CATEGORIES in
  // backend/models/subdivisions.js, which rejects anything outside this list.
  // SCOPE_CATEGORY_MF is what the subdivision dialog's Multi-family scope
  // filter matches on.
  export const SCOPE_CATEGORIES: string[] = ['Multifamily', 'Single Family', 'Other'];
  export const SCOPE_CATEGORY_MF = 'Multifamily';
